export const WHATSAPP_NUMBER = "905532038101";
export const PHONE_DISPLAY = "0553 203 81 01";
export const EMAIL = "berkeakdag2001@gmail.com";
export const INSTAGRAM_HANDLE = "@dyt.berkeakdag";
export const INSTAGRAM_URL = "https://instagram.com/dyt.berkeakdag";

export const waLink = (message = "Merhaba Berke, randevu almak istiyorum.") =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
